import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { Router } from 'react-router-dom';
import moment from 'moment';
import { createRoot } from 'react-dom/client';
import appConfig from 'app-config';
import 'console-config';
import HomeClient from 'flow/api-clients/home-client';
import getRoutes from './routes';
import { clearState, clearLoginData } from 'flow/actions/app-actions';
import { disconnectApp } from 'flow/actions/navigate-actions';
import { i18next } from 'flow/configure-locale';
import { history, store } from 'flow/configure-store';
import { addLanguageTohtml, getApplicationLanguage, setLanguageDirection } from 'flow/utils/browser-utils';
import { electronListeners } from 'flow/utils/electron-utils';
import { isUnauthorizedSafePath } from 'flow/utils/router-utils';
import ErrorBoundary from 'flow/components/error-boundary/ErrorBoundary';
import isElectron from 'is-electron';
import { isTeamsPopupUrl, TeamsAuthenticationPopup } from 'flow/route-components/TeamsAuthentication';
import MeetingMainUnauthorized from 'flow/components/meeting/shared/MeetingMainUnauthorized';
import 'css/main.less';
import AppContext from 'flow/contexts/app-context';
import { getOwnExtensionKey } from 'flow/selectors/selectors';
import { LocalesData } from 'flow/utils/locales-data';
import { registerInstance } from 'flow/utils/instance-count-utils';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'flow/contexts/query-client';
import { Provider } from 'react-redux';
var root = createRoot(document.getElementById('content'));
import * as microsoftTeams from '@microsoft/teams-js';
import { jsx as _jsx } from "react/jsx-runtime";
var applicationLanguage = getApplicationLanguage();
// hasOwn, not a bare lookup: this code comes from localStorage unvalidated,
// and LocalesData inherits from Object.prototype, so 'constructor' and
// 'toString' would give a truthy object whose fileCode is undefined -- and
// lang="undefined" is the thing the guard below exists to prevent. Leaving it
// undefined lets the markup's own default stand until the locale resolves.
var localeObject = Object.hasOwn(LocalesData, applicationLanguage) ? LocalesData[applicationLanguage] : undefined;
function importMomentLocales(_x) {
  return _importMomentLocales.apply(this, arguments);
}
function _importMomentLocales() {
  _importMomentLocales = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(LocalesData) {
    var locales, _iterator, _step, momentCode, _t;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          // Import all locales for moment
          locales = Object.values(LocalesData).map(function (locale) {
            return locale.momentCode;
          }).filter(Boolean);
          _iterator = _createForOfIteratorHelper(locales);
          _context3.prev = 1;
          _iterator.s();
        case 2:
          if ((_step = _iterator.n()).done) {
            _context3.next = 4;
            break;
          }
          momentCode = _step.value;
          _context3.next = 3;
          return import("moment/locale/".concat(momentCode));
        case 3:
          _context3.next = 2;
          break;
        case 4:
          _context3.next = 6;
          break;
        case 5:
          _context3.prev = 5;
          _t = _context3["catch"](1);
          _iterator.e(_t);
        case 6:
          _context3.prev = 6;
          _iterator.f();
          return _context3.finish(6);
        case 7:
          moment.locale(localeObject === null || localeObject === void 0 ? void 0 : localeObject.momentCode);
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 5, 6, 7]]);
  }));
  return _importMomentLocales.apply(this, arguments);
}
importMomentLocales(LocalesData);
setLanguageDirection(localeObject);
if (localeObject) {
  addLanguageTohtml(localeObject.fileCode);
}
console.info(appConfig.version);

// INTE-197: Alternate "entrypoint" to complete the authentication flow for Teams integration
if (isTeamsPopupUrl(window.location.pathname)) {
  HomeClient.notAuthorizedHandler = function (request) {
    console.warn('Request was not authorized: ', request);
  };
  root.render(/*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(TeamsAuthenticationPopup, {})
  }));
} else {
  registerInstance();
  electronListeners.registerArgsListener(store.dispatch);
  var lockOrientation = screen.lockOrientation || screen.mozLockOrientation || screen.msLockOrientation;
  if (lockOrientation) {
    try {
      lockOrientation('portrait');
    } catch (e) {
      console.warn('Orientation lock failed', e);
    }
  }

  // eslint-disable-next-line consistent-return
  HomeClient.notAuthorizedHandler = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
      var _store$getState, app, pathName, UnauthorizedVideoConference, renderConferenceApp, cleanPathName;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _store$getState = store.getState(), app = _store$getState.app;
            console.warn('Request was not authorized: ', request);
            pathName = window.location.pathname; // Not advised to do the following, antipattern
            // The user is not logged in, but should get entry to a conference app
            if (!(pathName.includes('/video') && !isElectron())) {
              _context.next = 1;
              break;
            }
            store.dispatch(clearState());
            UnauthorizedVideoConference = /*#__PURE__*/function (_React$Component) {
              function UnauthorizedVideoConference() {
                _classCallCheck(this, UnauthorizedVideoConference);
                return _callSuper(this, UnauthorizedVideoConference, arguments);
              }
              _inherits(UnauthorizedVideoConference, _React$Component);
              return _createClass(UnauthorizedVideoConference, [{
                key: "render",
                value: function render() {
                  return /*#__PURE__*/_jsx(Provider, {
                    store: store,
                    children: /*#__PURE__*/_jsx(AppContext.Provider, {
                      value: {
                        i18next: i18next
                      },
                      children: /*#__PURE__*/_jsx(Router, {
                        history: history,
                        children: /*#__PURE__*/_jsx(MeetingMainUnauthorized, {})
                      })
                    })
                  });
                }
              }]);
            }(React.Component);
            renderConferenceApp = function renderConferenceApp() {
              root.render(/*#__PURE__*/_jsx(ErrorBoundary, {
                children: /*#__PURE__*/_jsx(UnauthorizedVideoConference, {})
              }));
            };
            return _context.abrupt("return", renderConferenceApp());
          case 1:
            // If the current location renders its own unauthenticated state (login, the
            // UAE Pass callback), we do not want to redirect the user elsewhere or clear
            // state if they supplied wrong credentials.
            cleanPathName = pathName.replace(/^\/[A-Za-z]:/, '') // Remove drive letter with its leading slash
            .replace(/^\/+/, '/'); // Ensure single leading slash
            if (!isUnauthorizedSafePath(cleanPathName)) {
              store.dispatch(disconnectApp(app.get('embedded')))["finally"](function () {
                //Clear state from old info when your notAuthorized and/or thrown out
                //This will clear state and unregister your softphone.
                store.dispatch(clearState());
                // clearState keeps loginData; on a 401 / thrown-out we must drop
                // it too so the user is returned to SignIn (isSuccessLogin -> false)
                // instead of staying on Main with a dead session.
                store.dispatch(clearLoginData);
              });
            }
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x2) {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * Given a response to a XHR, check whether the user is verified or not.
   *
   * If the header does not exist on the response, we're generous and consider the user to be verified anyway.
   * Otherwise, we might e.g have trouble with the invitation of colleagues to Flow.
   */
  HomeClient.verifyUser = function (req) {
    var receivedExtensionKey = req.getResponseHeader('x-tvx-user');
    var storedExtensionKey = getOwnExtensionKey(store.getState());

    // This is a temporary fix to allow branding requests to go through.
    // API returns a 304 Not Modified which means we can get the data
    // from the cache, but if it is another user than last time
    // the x-tvx-user header will be for the old user which causes us
    // to not verify the request
    if (req.responseURL && req.responseURL.includes('api/internal/v2/branding/')) {
      return true;
    }
    return !receivedExtensionKey || !storedExtensionKey || receivedExtensionKey === storedExtensionKey;
  };
  var isInTeams = function isInTeams() {
    return window.location.pathname.includes('embed/teams');
  };
  var Root = /*#__PURE__*/function (_React$PureComponent) {
    function Root() {
      _classCallCheck(this, Root);
      return _callSuper(this, Root, arguments);
    }
    _inherits(Root, _React$PureComponent);
    return _createClass(Root, [{
      key: "render",
      value: function render() {
        return getRoutes();
      }
    }]);
  }(React.PureComponent);
  var renderApp = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(isInTeams() && !microsoftTeams.app.isInitialized())) {
              _context2.next = 1;
              break;
            }
            _context2.next = 1;
            return microsoftTeams.app.initialize();
          case 1:
            root.render(/*#__PURE__*/_jsx(ErrorBoundary, {
              children: /*#__PURE__*/_jsx(QueryClientProvider, {
                client: queryClient,
                children: /*#__PURE__*/_jsx(Root, {})
              })
            }));
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function renderApp() {
      return _ref2.apply(this, arguments);
    };
  }();
  i18next.on('loaded', renderApp);

  // if (module.hot) {
  //     module.hot.accept(['./routes'], renderApp);
  // }
}